import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Missioncard from "./MissionCard";
import laptopImg from "../../Assets/about.jpg";





function Mission() {

  return (
    <Container fluid className="about-section mission-page">
      <Particle />
      <Container className="mission-container">
        <header className="mission-hero">
          <h1 className="mission-hero-title">
            Our <strong className="purple">Mission</strong>
          </h1>
          <p className="mission-hero-lead">
            Building vibrant communities through belonging, equity, and ethical technology.
          </p>
        </header>

        <Row className="mission-top" style={{ justifyContent: "center" }}>
          <Col md={7} className="mission-left">
            <Missioncard />
          </Col>

          <Col md={5} className="mission-right">
            <div className="policy-card mission-image-card">
              <img src={laptopImg} alt="Choicest Fruit community" className="mission-image" />
            </div>
          </Col>
        </Row>

        <h2 className="mission-section-heading">
          Our <strong className="purple">Core Values</strong>
        </h2>

        <Techstack />
      </Container>
    </Container>
  );
}

export default Mission;
